---
nb:
  activemodel:
    attributes:
      green_months_bulk_update_form:
        from_month: Fra (måned)
        realized_price: Pris (NOK/MWh)
        to_month: Til (måned)
  errors:
    messages:
      from_month_should_not_be_after_to_month: Fra (måned) skal ikke være etter Til (måned)
  green_months:
    actions: Handlinger
    available_years: Tilgjengelige år
    header: Realiserte %{type} for %{power_plant}
    realized_price: Pris [NOK] per MWh
    volume: Volum [MWh]
  green_months_bulk_update_form:
    header: Angi %{type} priser for en tidsperiode
  messages:
    bulk_update_executed: Masseoppdatering utført
  update_all_green_months:
    header: Realiserte priser for %{power_plant} i %{year}
